/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet } from "../../funcs/schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$inboundSchema,
};

export const tool$schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-get-connection-api-v1-sandbox-github-oauth-connections-get",
    description: `Get Connection`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
